// Fix: prevent page shift when quick shop popup locks scroll
(function () {
  var sbWidth = 0;

  function measure() {
    // Only meaningful when scrollbar is visible
    var w = window.innerWidth - document.documentElement.clientWidth;
    if (w > 0) sbWidth = w;
  }

  measure();

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type !== 'attributes' || m.attributeName !== 'class') return;
      var body = document.body;
      if (body.classList.contains('quickshop-popup-show')) {
        body.style.paddingRight = sbWidth + 'px';
      } else {
        body.style.paddingRight = '';
        measure(); // re-measure for next open
      }
    });
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();

// Fix: keep header-single-line search bar always open
// The theme JS removes the 'open' attribute on desktop, which hides the inline search form
(function () {
  function initSingleLineSearch() {
    var details = document.querySelector('.header-single-line__item--search .search_details');
    if (!details) return;
    // Open immediately
    details.open = true;
    // Re-open whenever JS tries to close it
    new MutationObserver(function () {
      if (!details.open) details.open = true;
    }).observe(details, { attributes: true, attributeFilter: ['open'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSingleLineSearch);
  } else {
    initSingleLineSearch();
  }
})();

// Fix: Move Shopify chat widget upward on mobile to prevent overlap with Joy Loyalty widget
(function () {
  if (window.innerWidth > 768) return; // Only apply on mobile

  function moveChatWidget() {
    var chat = document.querySelector('inbox-online-store-chat');
    if (chat) {
      chat.style.setProperty('bottom', '200px', 'important');
    }
  }

  // Try immediately
  moveChatWidget();

  // Watch for the chat widget to be added to the DOM
  var observer = new MutationObserver(function () {
    moveChatWidget();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Also retry on load and after delays (chat widget loads async)
  window.addEventListener('load', function () {
    moveChatWidget();
    setTimeout(moveChatWidget, 1000);
    setTimeout(moveChatWidget, 3000);
    setTimeout(moveChatWidget, 5000);
  });
})();
